import firebaseApp, { FieldValue } from '../../config/firebase';

export const fireStore = firebaseApp.firestore();
export const fireAuth = firebaseApp.auth();
export const fireStorage = firebaseApp.storage();
export const fireFunctions = firebaseApp.functions();
export { FieldValue };

export const parseDocument = (doc) => ({ id: doc.id, ...doc.data() });
export const getFirstDocument = (snapshot) => parseDocument(snapshot.docs.shift());
export const handleDocument = (snapshot) => (snapshot.exists ? parseDocument(snapshot) : null);
export const handleMultiDocument = (snapshot) =>
  snapshot.empty ? [] : snapshot.docs.map(parseDocument);
export const onHandleSnapshot = (fn, handler) => (snapshot) => fn(handler(snapshot));
export const serverNowDateValue = () => FieldValue.serverTimestamp();
export const timestampToDate = (firebaseTimestamp) => firebaseTimestamp.toDate();

const getRefCallback = (ref, callback) => ref.get().then(callback);
const onRefCallback = (ref, fn, handler) => ref.onSnapshot(onHandleSnapshot(fn, handler));

export const getRefMany = (ref) => getRefCallback(ref, handleMultiDocument);
export const getRefOne = (ref) => getRefCallback(ref, handleDocument);
export const onRefMany = (ref, callback) => onRefCallback(ref, callback, handleMultiDocument);
export const onRefOne = (ref, callback) => onRefCallback(ref, callback, handleDocument);
